// import BaiduMap from 'vue-baidu-map'
// import element from './element'

const install = (Vue:any) => {
  if ((install as any).installed) {
    return
  }

  (install as any).installed = true

  // Vue.use(BaiduMap, { ak: 'PSt8rGwvMlO2xwdXRZbd7tBm' }) // 百度地图组件全局注册
  // Vue.use(element)
}

export default {
  install
}
